module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/data-tables/domain-icons/domain-icons.component.css
// module id = ./src/app/shared/data-tables/domain-icons/domain-icons.component.css
// module chunks = main